import "./styles.sass";

type LoaderProps = {
  width: number;
};

const NOMINAL_WIDTH = 104; // 4px из-за скругления

const Loader = (props: LoaderProps) => {
  const { width } = props;

  return (
    <div className="Loader">
      <div
        className="Loader__filled"
        style={{ width: `${NOMINAL_WIDTH - width}%` }}
      />
    </div>
  );
};

export default Loader;
